import React, { useContext } from "react";

import { Chat } from "app/userManagement/modules/generic";
import { withErrorBoundary } from "lib/hoc";

import { PrivateContext } from "lib/context";
import { useNavigate } from "react-router-dom";

const OperatorChat = () => {
  const { chatSetting } = useContext(PrivateContext);
  const navigate = useNavigate();
  const { isVendor } = chatSetting;

  if (!isVendor) {
    navigate("/");
  }

  return <Chat />;
};

export default withErrorBoundary(OperatorChat);
